import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Progress } from './progress.component';
import { IconModule } from '../icon/icon.module';

export { Progress } from './progress.component';

@NgModule({
  declarations: [
    Progress
  ],
  exports: [
    Progress
  ],
  imports: [
    CommonModule,
    IconModule,
  ]
})
export class ProgressModule { }
